import { Component } from '@angular/core';

@Component({
  selector: 'app-store-catalog',
  standalone: true,
  template: `
    <section class="placeholder-card">
      <div class="placeholder-head">
        <h2>Store Catalog</h2>
        <span class="coming-soon">Coming soon</span>
      </div>
      <p>Headless merchandise catalog management will be added here.</p>
    </section>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
      max-width: 1320px;
      box-sizing: border-box;
      margin: 0 auto;
    }

    .placeholder-card {
      border: 1px solid var(--app-border);
      background: var(--app-surface);
      border-radius: 14px;
      padding: 1rem;
    }
    h2 {
      margin: 0;
      font-size: var(--type-section-title);
      line-height: 1.2;
      letter-spacing: -0.01em;
      font-weight: 700;
      color: var(--app-text);
    }
    .placeholder-head {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.35rem;
    }
    .coming-soon {
      border: 1px solid #b7dff0;
      background: #eef6ff;
      color: var(--jci-blue);
      font-size: 0.76rem;
      font-weight: 700;
      border-radius: 999px;
      padding: 0.1rem 0.5rem;
      line-height: 1.3;
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }
    p {
      margin: 0;
      color: var(--app-muted);
      font-size: var(--type-body);
    }
  `
})
export class StoreCatalogComponent {}
